import { ProductGroupCode } from './ProductEnums'

export const VehicleIcons = {
  [ProductGroupCode.CAR]: 'sc-icon-car',
  [ProductGroupCode.TRUCK]: 'sc-icon-truck',
  [ProductGroupCode.MACHINERY]: 'sc-icon-agricultural'
}
